import { Stack } from "@mui/material";
import { TableBlock } from "./components/TableBlock";
import { HeaderBlock } from "./components/HeaderBlock";
import { FooterBlock } from "./components/FooterBlock";
import { ColumnsBlock } from "./components/ColumnsBlock";

export const DetailsBlock = ({ data, showDetails, setShowDetails, isPopup }) => {
  return (
    <Stack
      height={isPopup ? "100%" : "calc(100svh - 100px)"}
      backgroundColor="#F9FAFB"
      boxSizing="border-box"
      gap="30px"
      p="30px 40px 40px 40px"
      sx={{ overflowY: "auto", borderRadius: isPopup ? "12px" : "0px" }}
    >
      <HeaderBlock {...{ data, showDetails }} />
      {showDetails === "validity" ? (
        <ColumnsBlock {...{ data: data?.data }} />
      ) : (
        <TableBlock {...{ data: data?.data }} />
      )}

      <FooterBlock {...{ setShowDetails }} />
    </Stack>
  );
};
